import { render } from "./StatisticsResultsTable.vue?vue&type=template&id=4440b434&scoped=true"
import script from "./StatisticsResultsTable.vue?vue&type=script&lang=js"
export * from "./StatisticsResultsTable.vue?vue&type=script&lang=js"

import "./StatisticsResultsTable.vue?vue&type=style&index=0&id=4440b434&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4440b434"]])

export default __exports__